<template>
  <CustomCreateDialog
    dialogTitle="ساخت پکیج سوال مسابقات"
    dialogId="create-match-question-package-dialog"
    :isOkDisabled="isOkButtonDisabled"
    @ok="createLessonCategory"
  >
    <BCol cols="12">
      <TextInput
        customRules="required|min:1"
        inputId="name"
        inputLabel="نام پکیج را وارد کنید"
        inputPlaceholder="سوال 20 تایی"
        v-model="matchQuestionPackPayload.name"
      ></TextInput>
    </BCol>
    <BCol cols="12">
      <TextInput
        customRules="required|min:1"
        inputId="questionCount"
        inputLabel="تعداد سوالات پکیج را وارد کنید"
        inputPlaceholder="20"
        v-model="matchQuestionPackPayload.questionCount"
      ></TextInput>
    </BCol>
    <BCol cols="12">
      <CustomDatePicker
        inputId="matchQuestionPackExpireDate"
        @getSelectedDate="setExpireDate"
        inputLabel="تاریخ انقضای این پکیج"
        inputPlaceholder="1403/06/05"
      >
      </CustomDatePicker>
    </BCol>
    <BCol cols="12">
      <CustomAppendText
        :isText="true"
        customRules="required|min:1"
        inputId="matchQuestionPackCost"
        inputLabel="قیمت پکیج"
        inputPlaceholder="100000"
        v-model="matchQuestionPackPayload.cost"
      >
        <template #append> تومان </template>
      </CustomAppendText>
    </BCol>
  </CustomCreateDialog>
</template>
<script>
export default {
  emits: ["refetch"],
  data() {
    return {
      matchQuestionPackPayload: {
        name: null,
        questionCount: null,
        expireDate: null,
        cost: null,
      },
      isOkButtonDisabled: false,
    };
  },
  methods: {
    setExpireDate(expireDate) {
      if (expireDate) {
        this.matchQuestionPackPayload.expireDate = new Date(
          expireDate
        ).toISOString();
      } else {
        this.matchQuestionPackPayload.expireDate = null;
      }
    },
    async createLessonCategory() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let createNewMatchQuestionPackage = new CreateNewMatchQuestionPackage(
          _this
        );
        createNewMatchQuestionPackage.setRequestParamDataObj(
          _this.matchQuestionPackPayload
        );
        await createNewMatchQuestionPackage.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "پکیج سوال با موفقیت ایجاد شد.",
              },
            });
            _this.matchQuestionPackPayload = {
              name: null,
              questionCount: null,
              expireDate: null,
              cost: null,
            };
            this.$bvModal.hide("create-match-question-package-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    CustomCreateDialog,
    BCol,
    TextInput,
    CustomDatePicker,
    CustomAppendText,
  },
};
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import CustomAppendText from "@/views/components/Utils/CustomAppendText.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol } from "bootstrap-vue";
import { CreateNewMatchQuestionPackage } from "@/libs/Api/Matches";
</script>
